// extracted by mini-css-extract-plugin
module.exports = {"fakeLink":"ReactExamplesPage_fakeLink__B06G-"};